<ng-container *ngIf="employeeId === undefined; else loadImage">
    <div class="image-container" [ngStyle]="{'width.px': width, 'height.px': height}" [ngClass]="{'round': round}">
        <img class="profiler" [src]="miscellaneous.STOCK_EMPLOYEE_IMAGE">
    </div>
</ng-container>
<ng-template #loadImage>
    <div class="image-container" [ngStyle]="{'width.px': width, 'height.px': height}" [ngClass]="{'round': round}">
        <ng-container *ngIf="profilePhoto !== null && profilePhoto !== undefined && profilePhoto !== ''; else useStockImage">
            <img class="profiler" [src]="profilePhoto">
        </ng-container>
        <ng-template #useStockImage>
            <img class="profiler" [src]="miscellaneous.STOCK_EMPLOYEE_IMAGE">
        </ng-template>
    </div>
</ng-template>
